import "babel-polyfill";
import "./libs/slick";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {mobileNav} from "./modules/mobileNav";
import {accordion} from "./modules/accordion";
import {animationOnScroll} from "./modules/animationOnScroll";
import {customSelect} from "./modules/customSelect";
import {popups} from "./modules/popups";
import {testimonialsSlider} from "./modules/testimonialsSlider";
import {newsSlider} from "./modules/newsSlider";
import {scrollToAnchors} from "./modules/scrollToAnchors";
import {homePagesHash} from "./modules/homePageHash";
import {showMorePartners} from "./modules/showMorePartners";
import {getInTouchForm} from "./modules/getInTouchForm";
import {teamSlider} from "./modules/teamSlider";


binder({
    bounds: {
        "html": [constants, fullHeightPage],
        '.home': homePagesHash,
        ".header": [mobileNav, scrollToAnchors],
        ".accordion": accordion,
        ".has-animation": animationOnScroll,
        "select": customSelect,
        ".popup-link": popups,
        ".testimonials-slider": testimonialsSlider,
        ".news-slider": newsSlider,
        ".partners": showMorePartners,
        ".get-in-touch": getInTouchForm,
        ".team-list": teamSlider
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js